export default "__VITE_ASSET__lxuxJCz$__"